<div class="kortvisning">
  <!--<svg xmlns="http://www.w3.org/2000/svg" width="149" height="114.98" viewBox="0 0 149 114.98"><path d="m13.26,114.48c-3.69,0-6.73-1.2-9.14-3.61s-3.61-5.46-3.61-9.14V13.26c0-3.69,1.2-6.73,3.61-9.14S9.57.5,13.26.5h39.76l17.01,17.01h65.71c3.69,0,6.73,1.2,9.14,3.61s3.61,5.46,3.61,9.14v71.45c0,3.69-1.2,6.73-3.61,9.14s-5.46,3.61-9.14,3.61H13.26Z" style="fill:none; stroke:#000; stroke-miterlimit:10;"/></svg>-->
  <svg xmlns="http://www.w3.org/2000/svg" width="149.17" height="103.36" viewBox="0 0 149.17 103.36">
    <path d="m7.75,102.45l18.91-62.23h121.84l-16.61,55.38c-.64,2.16-1.88,3.91-3.72,5.25s-3.91,2.01-6.21,2.01H10.81c-2.93,0-5.38-.99-7.35-2.96s-2.96-4.42-2.96-7.35V11.96c0-2.93,1.18-5.57,3.53-7.93S9.03.5,11.96.5h35.71l15.28,15.28h59.01c2.16,0,4.07.48,5.73,1.43s2.99,2.26,4.01,3.91"
          style="fill:none; stroke:#000; stroke-miterlimit:10;"/>
  </svg>
  <div class="tittel">
    <h3>{{ mappe().navn }}</h3>
    @if (redigerbar()) {
      <button mat-icon-button
              [matMenuTriggerFor]="aktivMappeMeny.matMeny()"
              (click)="$event.stopPropagation()"
              class="mat-medium-icon-button meny">
        <mat-icon class="material-symbols-fet">more_vert</mat-icon>
      </button>
      <arkivmappe-meny [mappe]="mappe()" #aktivMappeMeny/>
    }
  </div>
</div>


<tittel-verdi tittel="Beskrivelse" stil="vertikal--med-linje" class="beskrivelse">
  <verdi>
    <html-formatert [innhold]="mappe().beskrivelse"/>
  </verdi>
</tittel-verdi>

<tittel-verdi tittel="{{'Tilgang'|translate}}" stil="vertikal--med-linje" class="skjerming" #skjermingBlokk>
  <verdi>
    @if (mappe().skjerming.skjermedeMedlemmerId.length > 0) {
      <skjerming-vis [skjerming]="skjerming()" [type]="skjermetEntitetType"/>
    } @else {
      <p>{{ 'Alle medlemmer kan lese denne mappen'|translate }}</p>
    }
    @if (redigerbar()) {
      <div class="handlinger">
        <button mat-button color="primary" (click)="redigerSkjerming()" matTooltip="{{'...'|translate}}">
          {{ 'Rediger tilgang'|translate }}
        </button>
      </div>
    }
  </verdi>
</tittel-verdi>

